module.exports = __webpack_public_path__ + "img/home.8aa72971.svg";